import React from "react";
import {
  AttachmentSection,
  Button,
  Divider,
  FormFieldSet,
  Modal,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../../components";
import { v4 as uuidv4 } from "uuid";

const AddDependentI94 = ({ onClose, isOpen }) => {
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        dependent: "",
        i94Number: "",
        dateOfLastArrival: "",
        statusExpiryDate: "",
        status: "",
        priorityDate: "",
        attachments: [
          {
            id: uuidv4(),
            attachmentName: "",
            attachmentComments: "",
            chooseFiles: [],
          },
        ],
      },
      {
        dependent: { type: "select", required: true },
        attachments: [ { chooseFiles: { type: "file" } } ]
      }
    );

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      console.log("form data:", formData);
      onClose();
    } else {
      console.log("error:", errors);
    }
  };

  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };

  return (
    <Modal
      title={"ADD DEPENDENT I-94 DETAILS"}
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-7xl"
    >
      <div>
        <div className="grid grid-cols-2 xl:grid-cols-3 mt-4 gap-x-6 gap-y-4 ">
          <FormFieldSet
            type="select"
            title={"Dependent"}
            placeholder="Select Dependent"
            value={formData.dependent}
            onChange={(value) => handleChange("dependent", value)}
            error={errors.dependent}
          />
          <FormFieldSet
            type="text"
            title={"I-94 Number"}
            placeholder="Enter I-94 Number"
            value={formData.i94Number}
            onChange={(value) => handleChange("i94Number", value)}
            error={errors.i94Number}
          />
          <FormFieldSet
            type="datepicker"
            title={"Date of Last Arrival"}
            placeholder="Select Date of Last Arrival"
            value={formData.dateOfLastArrival}
            onChange={(value) => handleChange("dateOfLastArrival", value)}
            error={errors.dateOfLastArrival}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Status Expiry Date"}
            placeholder="Select Status Expiry Date"
            value={formData.statusExpiryDate}
            onChange={(value) => handleChange("statusExpiryDate", value)}
            error={errors.statusExpiryDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="select"
            title={"Status"}
            placeholder="Select Status"
            value={formData.status}
            onChange={(value) => handleChange("status", value)}
            error={errors.status}
          />
          <FormFieldSet
            type="datepicker"
            title={"Priority Date"}
            placeholder="Select Priority Date"
            value={formData.priorityDate}
            onChange={(value) => handleChange("priorityDate", value)}
            error={errors.priorityDate}
            showDropdown={false}
          />
        </div>
        <div className="mt-6 ">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"ATTACHMENTS"} tag="p" />
              </div>
            }
          />
          <Divider />
        </div>
        <div>
          <div className="max-w-7xl">
            <AttachmentSection
              attachments={formData.attachments}
              onChange={(newAttachments) =>
                setFormData({ ...formData, attachments: newAttachments })
              }
              getAttachmentError={getAttachmentError}
              showNameField={true}
              showCommentsField={true}
            />
          </div>
        </div>

        <div className="flex gap-3 justify-end my-8">
          <Button title="Cancel" variant="outlined" onClick={onClose} />
          <Button title={"Save"} onClick={() => handleSave()} />
        </div>
      </div>
    </Modal>
  );
};

export default AddDependentI94;
